<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <div class="pb-4">Courses Thumbnail required <br />(300 x 400 px)</div>
        <div>
          <div style="overflow: hidden" @click="UploadImg1">
            <div class="dashed" v-if="Src1 == null">
              <div class="d-flex justify-center py-14">
                <div class="my-16">
                  <camerasvg />
                </div>
              </div>
            </div>

            <v-card v-model="UploadedImage1" v-else>
              <v-img :src="Src1" ref="Image1" max-height="550" contain></v-img>
            </v-card>
          </div>

          <input
            type="file"
            accept="image/png, image/gif, image/jpeg"
            style="display: none"
            ref="Img1"
            @change="SetImage1"
          />
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="12">
            <div class="pb-10">Course Banner required (1440 x 400px)</div>
            <div>
              <div style="overflow: hidden" @click="UploadImg2">
                <div class="dashed" v-if="Src2 == null">
                  <div class="d-flex justify-center py-10">
                    <div class="">
                      <camerasvg />
                    </div>
                  </div>
                </div>

                <v-card v-model="UploadedImage2" v-else>
                  <v-img
                    :src="Src2"
                    ref="Image2"
                    max-height="150"
                    contain
                  ></v-img>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img2"
                @change="SetImage2"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <div class="pt-5">Optional Additional Photos</div>
          <v-col cols="12" md="4">
            <div>
              <div style="overflow: hidden" @click="UploadImg3">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground3"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src3 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card v-model="UploadedImage3" v-else>
                  <v-img
                    :src="Src3"
                    ref="Image3"
                    max-height="500"
                    contain
                  ></v-img>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img3"
                @change="SetImage3"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="">
              <div style="overflow: hidden" @click="UploadImg4">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground4"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src4 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card v-model="UploadedImage4" v-else>
                  <v-img
                    :src="Src4"
                    ref="Image4"
                    max-height="500"
                    contain
                  ></v-img>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img4"
                @change="SetImage4"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="">
              <div style="overflow: hidden" @click="UploadImg5">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground5"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src5 == null"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card v-model="UploadedImage5" v-else>
                  <v-img
                    :src="Src5"
                    ref="Image5"
                    max-height="500"
                    contain
                  ></v-img>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img5"
                @change="SetImage5"
              />
            </div>
          </v-col>
         
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CameraBorderBoxSvg from "../../../assets/SvgIcons/CameraborderboxSvg.vue";
import Camerasvg from "../../../assets/SvgIcons/camerasvg.vue";
export default {
  name: "BlogImageUploaderComponent",
  components: { CameraBorderBoxSvg, Camerasvg },
   
  data() {
    return {
      svgBackground1: true,
      UploadedImage1: false,
      img1: {},
      Src1: null,

      svgBackground2: true,
      UploadedImage2: false,
      img2: {},
      Src2: null,

      svgBackground3: true,
      UploadedImage3: false,
      img3: {},
      Src3: null,

      svgBackground4: true,
      UploadedImage4: false,
      img4: {},
      Src4: null,

      svgBackground5: true,
      UploadedImage5: false,
      img5: {},
      Src5: null,
    };
  },

   methods: {
    UploadImg1() {
      this.$refs.Img1.click();
    },
    SetImage1() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src1 = reader.result;
        // this.$refs.Img1.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img1.files[0]);
      this.$emit("SetThumbnail", this.$refs.Img1.files[0]);
    },
    UploadImg2() {
      this.$refs.Img2.click();
    },
    SetImage2() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src2 = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img2.files[0]);
      this.$emit("SetBanner", this.$refs.Img2.files[0]);
    },

    UploadImg3() {
      this.$refs.Img3.click();
    },
    SetImage3() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src3 = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img3.files[0]);
      this.$emit("SetImage1", this.$refs.Img3.files[0]);
    },
    UploadImg4() {
      this.$refs.Img4.click();
    },
    SetImage4() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src4 = reader.result;
        // this.$refs.Image4.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img4.files[0]);
      this.$emit("SetImage2", this.$refs.Img4.files[0]);
    },
    UploadImg5() {
      this.$refs.Img5.click();
    },
    SetImage5() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src5 = reader.result;
        // this.$refs.Image5.src = reader.result;
      };
      reader.readAsDataURL(this.$refs.Img5.files[0]);
      this.$emit("SetImage3", this.$refs.Img5.files[0]);
    },
  },
};
</script>

<style scoped>
.dashed {
  border: 0.2px dashed #cacacd;
  border-style: 0.2px dashed;
  border-radius: 10px;
  max-height: 400px;
  opacity: 0.48;
  align-items: center;
}

.svgBackgroundSection {
}
h1 {
  font-family: "DM Sans";
  font-size: 30px;
  font-weight: 400;
  line-height: 39px;
}
/* .check {
  background-image: url("../../assets/css/rect.svg");
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
} */
</style>
